// @flow
// React Libs
import React from 'react';
// Components
import Tooltip from '../../../../../Resources/Common/Tooltip';
import SimpleDocumentComponent from '../../../Documents/SimpleDocumentComponent';

type Props = {
  hasRights: boolean,
  blocked: boolean,
  proposalUid: string
};

export default function ShareholdersList({
  hasRights,
  blocked,
  proposalUid
}: Props) {
  return (
    <SimpleDocumentComponent
      title="Table de capitalisation"
      tooltip={Tooltip.DocumentProjectShareholdersList.document}
      hasRights={hasRights}
      blocked={blocked}
      proposalUid={proposalUid}
    />
  );
}
